import * as Constants from '../constants';
import Endpoint from '../../api/Endpoint';
import mockActivation from '../data/activation';

export function updateTagSettings(settings) {
  return {
    type: Constants.UPDATE_TAG_SETTINGS,
    settings
  };
}

export function requestLocationAndLanguageChangeSubmit() {
  return {
    type: Constants.REQUEST_LOCATION_AND_LANGUAGE_CHANGE
  };
}

export function receiveLocationAndLanguageChangeSubmit(json, error) {
  return {
    type: Constants.RECEIVE_LOCATION_AND_LANGUAGE_CHANGE,
    activationStatus: json,
    error
  };
}

export function submitLocationAndLanguageChange(
  options = {},
  locationType,
  language
) {
  const useMockActivation = options.useMockActivation === 'true';
  const path = '/api/mc/v1/activation';
  const langBody =
    language === 'en'
      ? { translationEnabled: 'N', translationLanguage: '' }
      : { translationEnabled: 'Y', translationLanguage: language };

  return new Endpoint(
    path,
    requestLocationAndLanguageChangeSubmit,
    receiveLocationAndLanguageChangeSubmit
  )
    .withMock(
      useMockActivation
        ? mockActivation({ status: 'active', locationType, ...langBody })
        : null
    )
    .withOptions(options)
    .withMethod('PATCH')
    .withBody(JSON.stringify({ locationType: locationType, ...langBody }))
    .call();
}

export function updateInputErrors(inputName, display) {
  return {
    type: Constants.UPDATE_INPUT_ERRORS,
    inputName,
    display
  };
}

export function showToast(contentKey, variant = 'success') {
  return {
    type: Constants.SHOW_TOAST,
    contentKey,
    variant
  };
}

export function dismissToast() {
  return {
    type: Constants.DISMISS_TOAST
  };
}

export function requestActivationSubmit() {
  return {
    type: Constants.REQUEST_ACTIVATION
  };
}

export function receiveActivationSubmit(json, error) {
  return {
    type: Constants.RECEIVE_ACTIVATION,
    activationStatus: json,
    error
  };
}

export function submitActivation(options = {}, data = {}, method = 'POST') {
  const useMockActivation = options.useMockActivation === 'true';
  const path = '/api/mc/v1/activation';
  return new Endpoint(path, requestActivationSubmit, receiveActivationSubmit)
    .withMock(
      useMockActivation
        ? mockActivation({
            status: options.status,
            locationType: data.locationType
          })
        : null
    )
    .withOptions(options)
    .withMethod(method)
    .withBody(JSON.stringify(data))
    .call();
}

export function requestActivationStatusChangeSubmit() {
  return {
    type: Constants.REQUEST_ACTIVATION_STATUS_CHANGE
  };
}

export function receiveActivationStatusChangeSubmit(json, error) {
  return {
    type: Constants.RECEIVE_ACTIVATION_STATUS_CHANGE,
    activationStatus: json,
    error
  };
}

export function submitActivationStatusChange(options = {}, status) {
  const useMockActivation = options.useMockActivation === 'true';
  const path = '/api/mc/v1/activation';
  return new Endpoint(
    path,
    requestActivationStatusChangeSubmit,
    receiveActivationStatusChangeSubmit
  )
    .withMock(useMockActivation ? mockActivation({ status }) : null)
    .withOptions(options)
    .withMethod('PATCH')
    .withBody(JSON.stringify({ status: status }))
    .call();
}

export function requestActivationStatus() {
  return {
    type: Constants.REQUEST_ACTIVATION_STATUS
  };
}

export function receiveActivationStatus(json, error) {
  return {
    type: Constants.RECEIVE_ACTIVATION_STATUS,
    activationStatus: json,
    error
  };
}

export function getActivationStatus(options = {}) {
  const useMockData = options.useMockData === 'true';
  const path = '/api/mc/v1/activation';
  return new Endpoint(path, requestActivationStatus, receiveActivationStatus)
    .withMock(useMockData ? mockActivation({ status: options.status }) : null)
    .withOptions(options)
    .call();
}
